import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sx", "name", "children"];
import React, { useMemo } from 'react';
import { styled } from '@mui/material';
import { unstable_composeClasses as composeClasses, unstable_generateUtilityClass as generateUtilityClass } from '@mui/utils';
import { AppBar } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `AppBarStyled` is a React component that applies style overrides defined in the MUI theme.
 * It dynamically generates a styled container with a `root` class, which can be customized via MUI theme.
 * This component is useful for wrapping other components to ensure they respect the global theme styles.
 *
 * @component
 * @param {string} props.name - The name used to generate utility classes and for MUI theme overrides.
 * @param {React.ReactNode} props.children - The children elements to be wrapped and styled.
 *
 * @returns {JSX.Element} The styled wrapper component.
 *
 * @example
 * // Usage example
 * <AppBarStyled name="MyComponent">
 *   <MyComponent />
 * </AppBarStyled>
 */
export default function AppBarStyled(_ref) {
  var sx = _ref.sx,
    name = _ref.name,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = useMemo(function () {
    return composeClasses({
      root: ['root']
    }, function (slot) {
      return generateUtilityClass(name, slot);
    });
  }, [name]);
  var StyledAppBar = useMemo(function () {
    return styled(AppBar, {
      name: name,
      slot: 'Root',
      overridesResolver: function overridesResolver(_, styles) {
        return [styles.root];
      }
    })(function () {
      return {};
    });
  }, [name]);
  return (
    /*#__PURE__*/
    // @ts-ignore TODO danielmana fix unknown once it's on ui-packages#ui-core
    _jsx(StyledAppBar, _extends({
      sx: sx,
      className: classes.root
    }, rest, {
      children: children
    }))
  );
}